import { Trash2 } from "lucide-react";
import { Stepper } from "./Stepper";
import { useCart } from "../../lib/cart";
import { useContent } from "../../lib/content";
import { formatPrice } from "../../data/siteData";

const money = (v) => formatPrice(Math.round(v * 100) / 100);

export const CartLine = ({ item }) => {
  const { update, remove } = useCart();
  const { content } = useContent();
  const sup = item.product.kind === "pizza" ? content?.supplements ?? {} : {};
  const t = `cart-line-${item.id}`;
  return (
    <li className="py-5 border-b border-[#D4A359]/10" data-testid={t}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-display text-lg text-[#F7F4EB]">{item.product.name}</p>
          <p className="text-xs text-[#A2B3A7]">{money(item.unit)} l’unité</p>
        </div>
        <p className="font-semibold text-[#E5B66C]" data-testid={`${t}-total`}>{money(item.total)}</p>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-3 text-sm text-[#D6CFC0]">
        <span className="flex items-center gap-2">Qté <Stepper value={item.qty} min={1} onChange={(v) => update(item.key, { qty: v })} label="un article" testId={`${t}-qty`} /></span>
        {sup.viande && (
          <span className="flex items-center gap-2">Viande +{formatPrice(sup.viande.price)} <Stepper value={item.meat} max={5} onChange={(v) => update(item.key, { meat: v })} label="un supplément viande" testId={`${t}-meat`} /></span>
        )}
        {sup.legume && (
          <span className="flex items-center gap-2">Légume +{formatPrice(sup.legume.price)} <Stepper value={item.veg} max={5} onChange={(v) => update(item.key, { veg: v })} label="un supplément légume" testId={`${t}-veg`} /></span>
        )}
        <button type="button" onClick={() => remove(item.key)} className="ml-auto inline-flex items-center gap-1 text-xs text-[#F0A385] hover:text-[#F7F4EB]" data-testid={`${t}-remove`}>
          <Trash2 className="w-3.5 h-3.5" /> Retirer
        </button>
      </div>
    </li>
  );
};
